// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__Alodu","bigScore":"style__bigScore__-WBgR","targetIndicator":"style__targetIndicator__y3B+X"};